// import './button.css';
import React from 'react'



export const Button = props => {
            console.log(props);
    return (   
    <div>
       {props.children}
    </div>

     )  
}

export default Button

